module.exports = __webpack_public_path__ + "static/media/community-color.dee259a2.svg";